import { ParameterType } from '@/study-search/enums';

import { Filter } from '../models/filter';
import { BaseRouteHandler } from './BaseRouteHandler';
import { IRouteHandler } from './IRouteHandler';
import RoutingDefinitions from './RoutingDefinitions';

export class DurationRouteHandler extends BaseRouteHandler implements IRouteHandler {
	public canHandle(filters: Filter[]): boolean {
		const indexableFilters = filters.filter((_) => _.canBeIndexed());

		return indexableFilters.length === 1 && indexableFilters.some((_) => _.type === ParameterType.DURATION);
	}

	protected selectRoute(filters: Filter[]): any {
		return {
			name: RoutingDefinitions.DURATION_ROUTE,
			params: {
				duration: this.extractPath(filters.find((_) => _.type === ParameterType.DURATION)),
			},
		};
	}
}
